import type { Comment } from "@brookbush/types";

export const getCommentRepliesRecursive = (comment: Comment): Comment[] => {
	const replies = [];

	for (const reply of comment.replies || []) {
		replies.push(reply as Comment);

		if ((reply as Comment).replies?.length) {
			replies.push(...getCommentRepliesRecursive(reply as Comment));
		}
	}

	return replies;
};
